module.exports = __webpack_public_path__ + "img/flower-face.690b0606.jpg";